/**
 * Created by henian.xu on 2020/3/31.
 *
 */

import { get, post } from 'api/request';

export function applyDetail(id) {
    return get(this.url, { id });
}

export function applyList({ currentPage, pageSize }) {
    return get(this.url, {
        currentPage,
        pageSize,
    });
}

export function applyMaterialsDetail({ onlyTrainingApplyId, applyMaterialsId }) {
    return get(this.url, {
        onlyTrainingApplyId,
        applyMaterialsId,
    });
}

/**
 * 保存材料
 * @param onlyTrainingApplyId
 * @param applyMaterialsId
 * @param applyMaterialsValue       json 串
 * @returns {Promise<*>}
 */
export function saveApplyMaterials({ onlyTrainingApplyId, applyMaterialsId, applyMaterialsValue }) {
    return post(this.url, {
        onlyTrainingApplyId,
        applyMaterialsId,
        applyMaterialsValue,
    });
}
export function submitAudit({
    companyName,
    workRegionId,
    onlyTrainingApplyId,
    memberMsg,
    subsidyApplyType,
    signature,
    subsidyBankCard,
    bankAccount,
    openingBank,
}) {
    return post(this.url, {
        companyName,
        workRegionId,
        onlyTrainingApplyId,
        memberMsg,
        subsidyApplyType,
        signature,
        subsidyBankCard,
        bankAccount,
        openingBank,
    });
}
